var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-page info-group" }, [
    _c("div", { staticClass: "application-form-height" }, [
      _c(
        "div",
        [
          _vm.physicalInfo
            ? _c(
                "van-form",
                { ref: "form" },
                [
                  _c(
                    "van-cell-group",
                    [
                      _c("van-field", {
                        attrs: {
                          value: _vm._f("getValueByProp")(
                            _vm.physicalInfo,
                            "userInfo.userName"
                          ),
                          label: "姓名",
                          readonly: "",
                          required: "",
                          "input-align": "right",
                          center: ""
                        }
                      }),
                      _c("van-field", {
                        attrs: {
                          value: _vm._f("getValueByProp")(
                            _vm.physicalInfo,
                            "userInfo.sex"
                          ),
                          label: "性别",
                          readonly: "",
                          required: "",
                          "input-align": "right",
                          center: ""
                        }
                      }),
                      _c("van-field", {
                        attrs: {
                          value: _vm._f("getValueByProp")(
                            _vm.physicalInfo,
                            "userInfo.age"
                          ),
                          label: "年龄",
                          readonly: "",
                          required: "",
                          "input-align": "right",
                          center: ""
                        }
                      }),
                      _c("van-field", {
                        attrs: {
                          label: "手机号码",
                          readonly: "",
                          required: "",
                          "input-align": "right",
                          center: ""
                        },
                        model: {
                          value: _vm.physicalInfo.userInfo.mobile,
                          callback: function($$v) {
                            _vm.$set(_vm.physicalInfo.userInfo, "mobile", $$v)
                          },
                          expression: "physicalInfo.userInfo.mobile"
                        }
                      }),
                      _c("van-field", {
                        attrs: {
                          value: _vm._f("getValueByProp")(
                            _vm.physicalInfo,
                            "userInfo.idCard"
                          ),
                          label: "身份证号",
                          readonly: "",
                          required: "",
                          "input-align": "right",
                          center: ""
                        }
                      }),
                      _c("van-field", {
                        attrs: {
                          value: _vm._f("getValueByProp")(
                            _vm.physicalInfo,
                            "userType.userTypeName"
                          ),
                          label: "人员类型",
                          readonly: "",
                          "input-align": "right",
                          center: ""
                        }
                      }),
                      _c("van-field", {
                        attrs: {
                          value: _vm.MARITAL_STATUS.codeMapping.get(
                            _vm.physicalInfo.userInfo.maritalStatus
                          ),
                          label: "婚姻状况",
                          readonly: "",
                          required: "",
                          "input-align": "right",
                          center: ""
                        }
                      }),
                      _c("van-field", {
                        attrs: {
                          value: _vm._f("getValueByProp")(
                            _vm.physicalInfo,
                            "dept.deptName"
                          ),
                          label: "体检对口管理业务部门",
                          readonly: "",
                          "input-align": "right",
                          center: ""
                        }
                      }),
                      _c("van-field", {
                        attrs: {
                          label: "对口管理业务部门电话",
                          readonly: "",
                          "input-align": "right",
                          center: ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "input",
                              fn: function() {
                                return [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "tel",
                                      attrs: {
                                        href:
                                          "tel:" +
                                          _vm.$utils.getValueByProp(
                                            _vm.physicalInfo,
                                            "dept.phone"
                                          )
                                      }
                                    },
                                    [
                                      _c("svg-icon", {
                                        attrs: { name: "tel" }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "text" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("getValueByProp")(
                                              _vm.physicalInfo,
                                              "dept.phone"
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          3273119010
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "van-cell-group",
                    [
                      _c("van-field", {
                        attrs: {
                          label: "上一年体检医院",
                          placeholder: "--",
                          readonly: "",
                          "input-align": "right",
                          center: ""
                        },
                        model: {
                          value: _vm.physicalInfo.hospitalNameOfLastYear,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.physicalInfo,
                              "hospitalNameOfLastYear",
                              $$v
                            )
                          },
                          expression: "physicalInfo.hospitalNameOfLastYear"
                        }
                      }),
                      _c("van-field", {
                        attrs: {
                          rules: [
                            {
                              required: true,
                              message: "请选择",
                              trigger: "onChange"
                            }
                          ],
                          readonly: "",
                          clickable: "",
                          name: "className",
                          "is-link": "",
                          value:
                            _vm.selectHospital &&
                            _vm.selectHospital.hospitalName,
                          label: "本年度预约体检医院",
                          placeholder: "点击选择体检医院",
                          required: "",
                          "input-align": "right",
                          center: ""
                        },
                        on: {
                          click: function($event) {
                            _vm.hospitalPopupVisible = true
                          }
                        }
                      }),
                      _vm.selectHospital && _vm.selectHospital.hospitalName
                        ? _c("van-cell", {
                            attrs: {
                              value: _vm.amount || "--",
                              title: "所选医院体检额度",
                              "value-class": "red-text"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "right-icon",
                                  fn: function() {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "red-text pl-1" },
                                        [_vm._v("元")]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1783214118
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.selectHospital && _vm.selectHospital.hospitalName
                    ? _c("hospital-files", {
                        attrs: { name: _vm.selectHospital.hospitalName }
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "buttons-panel" },
                    [
                      _c(
                        "van-button",
                        {
                          staticClass: "submit",
                          attrs: {
                            type: "info",
                            size: "large",
                            loading: _vm.loading
                          },
                          on: { click: _vm.formSubmit }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.thisYearSelected
                                  ? "修改体检医院"
                                  : "选择体检医院"
                              ) +
                              " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "van-popup",
            {
              attrs: { position: "bottom" },
              model: {
                value: _vm.hospitalPopupVisible,
                callback: function($$v) {
                  _vm.hospitalPopupVisible = $$v
                },
                expression: "hospitalPopupVisible"
              }
            },
            [
              _vm.physicalInfo &&
              _vm.physicalInfo.hospitals &&
              _vm.physicalInfo.hospitals.length
                ? _c("van-picker", {
                    attrs: {
                      title: "选择医院",
                      "show-toolbar": "",
                      columns: _vm.physicalInfo.hospitals,
                      "default-index": _vm.physicalInfo.hospitals.findIndex(
                        function(hospitals) {
                          return (
                            _vm.selectHospital &&
                            hospitals.hospitalId ===
                              _vm.selectHospital.hospitalId
                          )
                        }
                      ),
                      "value-key": "hospitalName"
                    },
                    on: {
                      confirm: _vm.handleSelectHospital,
                      cancel: function($event) {
                        _vm.hospitalPopupVisible = false
                      }
                    }
                  })
                : _c("span", [_vm._v("暂无数据")])
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }